import type { SVGProps } from 'react';
const SvgThumbsUpSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.903 9.966c.643 0 1.162.493 1.162 1.103v8.828c0 .61-.52 1.103-1.162 1.103H5.161C4.52 21 4 20.507 4 19.897v-8.828c0-.61.519-1.103 1.161-1.103zM13.82 5c.99 0 1.793.762 1.793 1.703v.145c0 .235-.047.47-.138.686l-1.023 2.432h5.806c.962 0 1.742.74 1.742 1.655 0 .679-.432 1.262-1.049 1.517.617.255 1.049.838 1.049 1.517 0 .807-.61 1.48-1.415 1.624.16.252.254.545.254.859 0 .765-.545 1.407-1.285 1.596.08.19.123.397.123.61 0 .915-.78 1.656-1.741 1.656h-3.19a6 6 0 0 1-3.626-1.21l-.443-.335a2.16 2.16 0 0 1-.87-1.724v-6.434c0-.514.126-1.021.366-1.48l2.04-3.876c.304-.575.925-.941 1.607-.941"
    />
  </svg>
);
export default SvgThumbsUpSolid;
